interface EmptyProps {
  icon?: string;
  title: string;
  hint?: string;
}

/** Пустое состояние списка. */
export function Empty({ icon = '🗒', title, hint }: EmptyProps): JSX.Element {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: 'var(--space-xl)',
        color: 'var(--tg-hint)',
      }}
    >
      <div style={{ fontSize: 48, marginBottom: 'var(--space-md)' }}>{icon}</div>
      <div style={{ fontSize: 'var(--font-md)', fontWeight: 600, color: 'var(--tg-text)' }}>{title}</div>
      {hint && <div style={{ fontSize: 'var(--font-sm)', marginTop: 'var(--space-sm)' }}>{hint}</div>}
    </div>
  );
}
